import React, { useEffect, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const ClientsCarousel = () => {
  const [clients, setClients] = useState([]);
  const [emblaRef] = useEmblaCarousel(
    { loop: true, align: 'start', slidesToScroll: 1 },
    [Autoplay({ delay: 3000, stopOnInteraction: false })]
  );

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/api/clients`, { timeout: 15000 })
      .then(res => { if (!cancelled) setClients(res.data?.items || []); })
      .catch(() => { if (!cancelled) setClients([]); });
    return () => { cancelled = true; };
  }, []);

  // Don't render the section only when we're still loading initial state.
  // If API returns empty (e.g., before seed runs), we still render nothing —
  // but the backend auto-seeds on startup so this only affects the first
  // few seconds after a fresh deploy.
  if (clients.length === 0) return null;

  return (
    <div className="clients-carousel">
      <div className="embla" ref={emblaRef}>
        <div className="embla__container">
          {clients.map(client => (
            <div key={client.id} className="embla__slide-client">
              <div className="client-logo-wrapper">
                <img src={client.logo} alt={client.name} className="client-logo" loading="lazy" decoding="async" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClientsCarousel;
